<template>
    <div class="container homepage-container">
        <div class="row" v-if="seminar !== null">
            <div class="col-12 col-md-6 col-lg-7 main-text">
                <div class="pr-5">
                    <h1>{{ seminar.name }}</h1>
                    <div class="description mt-3" v-html="seminar.description"></div>
                </div>
            </div>
            <div class="col-12 col-md-6 col-lg-5">
                <form class="card login-form animated backInUp" @submit.prevent="login()">
                    <div class="card-body mt-4 mb-4 text-center" v-if="loggedOut === true">
                        <font-awesome-icon icon="check" size="2x" class="text-danger"/>
                        <br>
                        Úspešne ste absolvovali seminár
                        <router-link :to="{name: 'homepage'}" class="btn btn-outline-secondary btn-sm mt-3">
                            Prihlásiť sa znovu
                        </router-link>
                    </div>
                    <template v-if="loggedOut === false">
                        <div class="card-header">
                            Prihlásiť sa na seminár
                        </div>
                        <div class="card-body">
                            <div class="form-group">
                                <label for="attendeeName" class="mb-0">Vaše meno a priezvisko</label>
                                <input id="attendeeName" type="text" class="form-control" v-model="formData.name">
                                <small class="text-danger" v-if="showFormErrors && formData.name.length < 3">
                                    Zadajte Vaše meno
                                </small>
                            </div>
                            <div class="form-group">
                                <label for="member" class="mb-0">Váš finančný poradca</label>
                                <select id="member" class="form-control" v-model="formData.member">
                                    <option></option>
                                    <option v-for="member in seminar.seminarMember" :value="member.id">
                                        {{ member.fullName }}
                                    </option>
                                </select>
                                <small class="text-danger" v-if="showFormErrors && !formData.member">
                                    Vyberte Vášho finančného poradcu
                                </small>
                            </div>
                            <button type="submit" class="btn btn-danger">Prihlásiť sa</button>
                        </div>
                    </template>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Homepage",
    computed: {
        seminar() {
            return this.$store.state.seminar.seminar;
        },
        loggedOut() {
            return this.$route.query.logged == '1';
        }
    },
    mounted() {
        this.$store.dispatch('seminar/getPublic').then((data) => {
            if (data.account !== null) {
                this.$router.push({name: 'seminar'})
            }
        })
    },
    methods: {
        login() {
            if (this.formData.member === '' || this.formData.member === null || this.formData.name.length < 3) {
                this.showFormErrors = true;
            } else {
                this.$store.dispatch('seminar/login', {seminarId: this.seminar.id, ...this.formData}).then(() => {
                    this.$router.push({name: 'seminar'})
                })
            }
        }
    },
    data() {
        return {
            showFormErrors: false,
            formData: {
                name: '',
                member: null,
            },
        }
    }
}
</script>

<style lang="scss" scoped>
.homepage-container {
    .main-text {
        display: flex;
        flex-direction: column;
        justify-content: center;
    }

    .login-form {
        .card-header {
            background: transparent;
            padding: 30px 30px 0;
            border-width: 0;
            font-weight: bold;
            font-size: 20px;
        }

        .card-body {
            padding: 30px;
        }
    }


}
</style>